import { useEffect, useState } from 'react';

export type VisualViewportInset = {
  /** Offset from layout bottom to the visible viewport bottom (keyboard overlap). */
  keyboardInset: number;
  height: number;
  width: number;
  offsetTop: number;
  offsetLeft: number;
};

export function readVisualViewportInset(): VisualViewportInset {
  const vv = typeof window !== 'undefined' ? window.visualViewport : null;
  if (!vv) {
    return {
      keyboardInset: 0,
      height: typeof window !== 'undefined' ? window.innerHeight : 0,
      width: typeof window !== 'undefined' ? window.innerWidth : 0,
      offsetTop: 0,
      offsetLeft: 0,
    };
  }
  const keyboardInset = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
  return {
    keyboardInset,
    height: vv.height,
    width: vv.width,
    offsetTop: vv.offsetTop,
    offsetLeft: vv.offsetLeft,
  };
}

/**
 * Tracks visualViewport so bottom chrome can clear the soft keyboard.
 */
export function useVisualViewportInset(): VisualViewportInset {
  const [inset, setInset] = useState(readVisualViewportInset);

  useEffect(() => {
    const vv = window.visualViewport;
    const onChange = () => setInset(readVisualViewportInset());
    vv?.addEventListener('resize', onChange);
    vv?.addEventListener('scroll', onChange);
    window.addEventListener('resize', onChange);
    onChange();
    return () => {
      vv?.removeEventListener('resize', onChange);
      vv?.removeEventListener('scroll', onChange);
      window.removeEventListener('resize', onChange);
    };
  }, []);

  return inset;
}
